import { render, staticRenderFns } from "./ServerStatus.vue?vue&type=template&id=0a281ac8&"
import script from "./ServerStatus.vue?vue&type=script&lang=js&"
export * from "./ServerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports